import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Player, BigPlayButton, ControlBar, Shortcut } from 'video-react'

class VerticalVideo extends Component {
  constructor (props) {
    super(props)

    this.play = this.play.bind(this)
    this.pause = this.pause.bind(this)
  }

  componentDidMount () {
    // Set initially active vertical to play
    const { activeVertical, index } = this.props

    if (activeVertical === index) {
      this.play()
    }
  }

  componentDidUpdate (prevProps) {
    const { activeVertical, index } = this.props

    if (prevProps.activeVertical !== this.props.activeVertical) {
      // Play active vertical
      if (activeVertical === index) {
        this.play()
      } else {
        this.pause()
      }
    }
  }

  play () {
    this.refs.player.play()
  }

  pause () {
    this.refs.player.pause()
  }

  render () {
    const { vertical, isMobile } = this.props
    const screen = isMobile ? 'mobile' : 'desktop'

    // On deskop, videos have a defined size.
    // Until then, fluid == true so the width and height props are ignored
    // by react-video.
    return (
      <Player
        className='video video--vertical'
        fluid={isMobile}
        height='auto'
        loop
        muted
        playsInline
        poster={vertical[`image_${screen}`].url}
        preload='auto'
        ref='player'
        src={vertical[`video_${screen}`].file.url}
        width={976}
      >
        <BigPlayButton disabled />
        <ControlBar disabled />
        <Shortcut disabled />
      </Player>
    )
  }
}

VerticalVideo.propTypes = {
  vertical: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool,
  activeVertical: PropTypes.number
}

export default VerticalVideo



// WEBPACK FOOTER //
// ./src/components/vertical-video.js